import { Component, effect, OnInit, input, inject, signal } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

import { QrCodeOptions } from './qr-code.model';
import { ApQrCodeService } from './qr-code.service';

/**
 * @module ApQrCodeModule
 *
 * @ngdoc component
 * @name ApQrCodeComponent
 */
@Component({
    selector: 'ap-qr-code',
    templateUrl: './qr-code.component.html',
    providers: [ApQrCodeService]
})
export class ApQrCodeComponent implements OnInit {
    private readonly qrCodeService = inject(ApQrCodeService);

    /**
     * Required - Data to generate QR code with
     */
    public readonly data = input.required<string>();

    /**
     * Additional options for QR code
     */
    public readonly options = input<QrCodeOptions>();

    protected qrCode = signal<SafeHtml>(null);
    protected ariaLabel = signal<string>('QR Code');

    public constructor() {
        effect(() => {
            this.fetchQrCode();
        });
    }

    public ngOnInit(): void {
        const options = this.options();
        this.ariaLabel.set((options && options.ariaLabel) || 'QR Code');
    }

    private fetchQrCode(): void {
        this.qrCodeService.generate(this.data(), this.options()).then((qr) => this.qrCode.set(qr));
    }
}
